import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlayButton = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.3418 3.97247C5.49179 3.88207 5.67809 3.87616 5.83301 3.95783L20.2334 11.5584C20.397 11.645 20.4999 11.8147 20.5 11.9998C20.4999 12.1849 20.397 12.3556 20.2334 12.4422L5.83301 20.0428C5.6782 20.1242 5.49165 20.1184 5.3418 20.0281C5.19196 19.9377 5.09981 19.7754 5.09961 19.6004V4.40021L5.10352 4.33478C5.1232 4.18537 5.21085 4.05162 5.3418 3.97247Z",
		fill: "currentColor"
	})
});
export default SvgPlayButton;
